import {axios as http} from "@/plugins/http"
import QuerySerializer from "@/services/QuerySerializer"

export default class Api {
    static saveWishLink(wishId, link) {
        return http.post("/api/v1/wishlist/save-wish-link", null, {
            params: {
                wish_id: wishId,
                link_name: link,
            },
            paramsSerializer: (params) => QuerySerializer.stringify(params),
        }).then((resp) => {
            return resp.data["item"]
        })
    }

    static saveWish(
        wishId,
        currencyId,
        themeIds,
        wishName,
        wishDescJson,
        wishAmount,
        wishAlias,
        categoryId,
    ) {
        return http.post("/api/v1/wishlist/save-wish", null, {
            params: {
                ...(wishId !== null && wishId !== undefined ? { wish_id: wishId } : {}),
                currency_id: currencyId,
                theme_ids: themeIds,
                wish_name: wishName,
                wish_desc_json: wishDescJson,
                wish_amount: wishAmount,
                wish_alias: wishAlias,
                category_id: categoryId,
            },
            paramsSerializer: (params) => QuerySerializer.stringify(params),
        }).then((resp) => {
            return resp.data["item"]
        })
    }
}

